// extracted by mini-css-extract-plugin
export default {"box":"ExternalAddressView_box__awp9d"};